export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtDmslogo';
export const NAME = 'DmsLogo';
